import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useOrderQuery } from './order.generated';
import { Button, fToCurrency } from '@web/utils';

const OrderSuccessPage = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [data] = useOrderQuery({
    variables: { orderId: orderId || '' },
  });

  const order = data.data?.currentUser?.order;

  const hasZeroPricedItem = useMemo(() => {
    return order?.lineItems.some((item) => item.price === 0);
  }, [data.data?.currentUser?.order]);

  return (
    <div className="container py-15-0 md:py-8-0 flex items-center justify-center">
      <div className="order-details-container p-4-0 md:p-2-0 rounded-base shadow-lg text-body1 w-full md:max-w-44-0">
        <p className="font-bd text-center text-2-5 md:text-2-0">
          {t('order.order_success')}
        </p>
        <p className="my-2-0 border-b border-primary-border text-center font-md pb-0-5 w-1/2 mx-auto">
          {t('order.order_details')}:
        </p>
        {order ? (
          <div className="flex justify-center gap-2-0">
            <div className="leading-1-71">
              <p>{t('order.order_id')}</p>
              {/* <p>{t('order.orderStatus')}</p> */}
              <p>{t('order.total_net')}</p>
            </div>
            <div className="leading-1-71">
              <p className="font-md">{order.id}</p>
              <p className="font-md">{order.status}</p>
              <p className="font-md">
                {hasZeroPricedItem ? '*' : fToCurrency(order.totalNet || 0)}
              </p>
            </div>
          </div>
        ) : (
          <p className="text-center font-md">{t('order.order_not_found')}</p>
        )}
        <Button className="mt-4-0 mx-auto block" onClick={() => navigate('/')}>
          {t('global.go_home')}
        </Button>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
